const FederalWayStorymap: React.FC = () => {
    return (
    <div className="fw-page">
        <div className="fw-eyebrow">
            <div className="fw-eyebrow-bar"></div>
            <span className="fw-eyebrow-text">Federal Way · Downtown Core</span>
        </div>

        <h1 className="fw-title">Market Context &amp; Area Overview</h1>
        <p className="fw-subtitle">City Center Core · 2026</p>

        <div className="fw-divider"></div>

        <div className="fw-body">
            <p>Anchored by a strong retail base and a concentration of employment, the Federal Way Downtown Core serves as a regional destination that attracts both residents and visitors. A market study underscores the importance of this area as Federal Way's primary opportunity for catalytic growth, particularly as the city looks to strengthen its identity as a vibrant, connected urban center.</p>
            <p>Commercial real estate trends reflect a market that is stable and evolving. While retail inventory has consolidated within the City Center, performance remains resilient, supported by steady demand and opportunities for experiential retail growth. Office space has seen overall gains citywide, and while new development in the City Center has been limited, rising lease rates and relatively competitive pricing position the area as an alternative within the broader King County market. These dynamics suggest an environment where strategic investment and repositioning can unlock additional value.</p>
        </div>

        <div className="fw-callout">
            <p>This companion mapping tool allows users to easily review parcel details within Federal Way's downtown core — including zoning, valuation, ownership, acreage, and more.</p>
        </div>

        <div className="fw-tools-label">Tool guide</div>
        <div className="fw-tools">

            <div className="fw-tool">
                <div className="fw-tool-icon teal">
                    <svg fill="none" stroke="#0F6e56" height={15} width={15} viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                </div>
                <div>
                    <div className="fw-tool-label">Tour</div>
                    <div className="fw-tool-desc">Take a quick guided tour of the mapping tool to get oriented with the key features.</div>
                </div>
            </div>

            <div className="fw-tool">
                <div className="fw-tool-icon blue">
                    <svg fill="none" stroke="#185FA5" height={15} width={15} viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"></path></svg>
                </div>
                <div>
                    <div className="fw-tool-label">Map options</div>
                    <div className="fw-tool-desc">Review the area by parcel, land use, demographics, or transit availability.</div>
                </div>
            </div>

            <div className="fw-tool">
                <div className="fw-tool-icon amber">
                    <svg fill="none" stroke="#854F0B" height={15} width={15} viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                </div>
                <div>
                    <div className="fw-tool-label">Custom area select</div>
                    <div className="fw-tool-desc">Draw a custom boundary to zero in on specific areas of interest within the downtown core.</div>
                </div>
            </div>

            <div className="fw-tool">
                <div className="fw-tool-icon purple">
                    <svg fill="none" stroke="#0F6e56" height={15} width={15} viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                </div>
                <div>
                    <div className="fw-tool-label">Export to Excel</div>
                    <div className="fw-tool-desc">Download filtered parcel results into a spreadsheet for offline review and analysis.</div>
                </div>
            </div>

        </div>
    </div>
    )
};

export default FederalWayStorymap;